import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CustomerMenuItem from "./CustomerMenuItem";
import { fetchMenuById } from "../../api/menuApi";
import { useSelector } from "react-redux";
import WaiterIcon from "../icons/WaiterIcon";
import "../../css/CustomerMenu.css";
import WaiterAIModal from "../ModalComponents/WaiterAIModal";
import ShoppingCart from "../CartComponents/ShoppingCart";

/**
 * A component that displays a menu with multiple sections and their items.
 * Each section contains a list of items displayed using the `CustomerMenuItem` component.
 *
 * @component
 * @returns {JSX.Element} The rendered CustomerMenu component.
 */
const CustomerMenu = ({ menuId: propMenuId, inAdmin = false }) => {
  const [sections, setSections] = useState([]); // initialize with an empty array
  const frontendPath = window.location.pathname;

  const { menuId: urlMenuId } = useParams(); // Get menuId from URL if not passed as prop
  const menuId = propMenuId || urlMenuId; // Use prop if available, otherwise use URL param
  const restaurantId = localStorage.getItem("restaurant")
    ? JSON.parse(localStorage.getItem("restaurant")).id
    : null;

  const [isWaiterAIChatOpen, setIsWaiterAIChatOpen] = useState(false);
  const isMobile = useSelector((state) => state.mobile.isMobile);
  const [showCartModal, setShowCartModal] = useState(false);

  useEffect(() => {
    // load the default menu on component mount
    const fetchMenu = async () => {
      try {
        const menuData = await fetchMenuById(menuId, frontendPath);
        setSections(menuData.sections);
      } catch (error) {
        console.error("Error fetching menu:", error);
      }
    };
    fetchMenu();
  }, [frontendPath, menuId]);

  return (
    <div
      className="CustomerMenu"
      style={{
        padding: isMobile
          ? inAdmin
            ? "0 1em"
            : "2em"
          : inAdmin
          ? "0 2em"
          : "2em",
      }}
    >
      {!inAdmin && <h1 className="CustomerMenu-title">menu</h1>}
      <ShoppingCart
        showModal={showCartModal}
        setShowModal={setShowCartModal}
        menuId={menuId}
        restaurantId={restaurantId}
      />
      {sections.map((section, sectionIndex) => (
        <div className="CustomerMenu-section" key={sectionIndex}>
          <h2 className="CustomerMenu-section-name">{section.name}</h2>
          {section.items.map((item, itemIndex) => {
            const modelUrl = item.model?.url || null;
            const modelType = item.model?.type || null;
            const flatModelUrl = item.model?.url2d || null;
            return (
              <CustomerMenuItem
                key={itemIndex}
                id={item.id}
                photo={item.photo}
                name={item.name}
                description={item.description}
                price={item.price}
                likes={item.likes}
                modelURL={modelUrl}
                flatModelUrl={flatModelUrl}
                type={modelType}
              />
            );
          })}
        </div>
      ))}
      <div
        className="CustomerMenu-waiter-ai-button"
        onClick={() => setIsWaiterAIChatOpen(true)}
      >
        <WaiterIcon />
      </div>
      <WaiterAIModal
        isOpen={isWaiterAIChatOpen}
        onRequestClose={() => setIsWaiterAIChatOpen(false)}
      />
    </div>
  );
};

export default CustomerMenu;
